import React from "react";
import { Divider, Box, Grid, Typography } from "@material-ui/core";
//css
import StylesCss from "./styles";
const useStyles = StylesCss();

export default function cardNotaFiscal({ dataNotaFiscal, title }) {
    const classes = useStyles();
    
    const sumVlTotal = dataNotaFiscal.reduce(function (acc, obj) {
        return acc + parseFloat(obj.VM_TOT_ITEM.replace(",", "."));
    }, 0);

    const sumTotalDescont = dataNotaFiscal.reduce(function (acc, obj) {
        return acc + parseFloat(obj.VM_DESC_ITEM.replace(",", "."));
    }, 0);

    function formataMoeda(val) {
        return parseFloat(val).toLocaleString("pt-br", { style: "currency", currency: "BRL" });
    }

    function calcPercentual(valTot, valTotDesc) {
        return (valTotDesc / valTot) * 100;
    }

    const Grid4 = ({ data1, data2, data3, data4 }) => {
        return (
            <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <Grid item style={{ paddingRight: "10px" }} sm={data2 ? 3 : 5}>
                    {data1}
                </Grid>
                <Grid item sm={data2 ? 3 : 1}>
                    {data2 ? data2 : ""}
                </Grid>
                <Grid item sm={3}>
                    {data3 ? data3 : ""}
                </Grid>
                <Grid item sm={3}>
                    {data4}
                </Grid>
            </Grid>
        );
    };

    return (
        <Grid container direction="row" justifyContent="flex-center">
            <Grid item sm={12}>
                <Box p={1} className={classes.cardNotaFiscal}>
                    <div className={classes.rowCardNotaFiscal}>
                        <Typography variant="subtitle2">{title}</Typography>
                        <br />
                        <b>
                            <Grid4
                                data1={"Produto"}
                                data2={"Valor unitário"}
                                data3={"Quantidade"}
                                data4={"Preço"}
                            />
                        </b>
                        <div sclassName={classes.itensCard}>
                            {dataNotaFiscal.map((e, i) => {
                                return (
                                    <>
                                        <Divider />
                                        <div className={classes.rowCardNotaFiscal}>
                                            <Grid4
                                                key={i}
                                                data1={e.NM_PROD}
                                                data2={formataMoeda(e.VM_UNIT.replace(",", "."))}
                                                data3={e.QT_ITEM}
                                                data4={formataMoeda(
                                                    e.VM_TOT_ITEM.replace(",", ".")
                                                )}
                                            />
                                        </div>
                                    </>
                                );
                            })}
                        </div>

                        <Divider />
                        <Grid4 data1={"Subtotal"} data4={formataMoeda(sumVlTotal)} />
                        <Grid4
                            data1={`Desconto Aplicado(${calcPercentual(
                                sumVlTotal,
                                sumTotalDescont
                            ).toFixed(1)}%)`}
                            data4={formataMoeda(sumTotalDescont)}
                        />
                        <b>
                            <Grid4
                                data1={"Valor Liquido"}
                                data4={formataMoeda(sumVlTotal - sumTotalDescont)}
                            />
                        </b>
                    </div>
                </Box>
            </Grid>
        </Grid>
    );
}
